import { IMG } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";
import { Overline, CtaLink } from "@/components/site/primitives";
import ConceptTag from "@/components/site/ConceptTag";

export default function VisionBlock({ withCta = true }) {
  return (
    <section className="bg-rp-bg" data-testid="vision-section">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
          <Reveal>
            <Overline>The Vision</Overline>
            <h2 className="mt-5 font-display text-4xl font-light uppercase leading-[0.95] tracking-tight md:text-5xl lg:text-6xl">
              The Next Generation of the Road Trip.
            </h2>
            <div className="mt-8 space-y-5 text-base leading-relaxed text-white/55">
              <p>
                Transportation is changing, but the roadside experience has largely remained the same.
                RestPower was created around a simple idea: as vehicles become electric, the places where
                travelers stop should evolve too.
              </p>
              <p>
                Our vision is to create destinations where clean-energy infrastructure meets comfort,
                convenience, and hospitality.
              </p>
            </div>
            {withCta && (
              <div className="mt-9">
                <CtaLink to="/vision" data-testid="vision-cta">Learn More About Our Vision</CtaLink>
              </div>
            )}
          </Reveal>

          <Reveal delay={0.1}>
            <div className="relative overflow-hidden rounded-3xl border border-white/10">
              <img src={IMG.lounge} alt="RestPower interior concept" loading="lazy"
                className="h-[420px] w-full object-cover md:h-[560px]" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
              <ConceptTag className="absolute left-5 top-5" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
